
import React from 'react';
import {
  Card,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
  },
  fontWeightMedium: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  cardHeader: {
    color: theme.palette.secondary.main,
  },
}));

function DisputeInfo({
  disputeDate,
  stripeDisputeId,
}) {
  const classes = useStyles();
  const theme = useTheme();

  return (

    <Card className={classes.card}>
      <CardHeader
        style={{ color: theme.palette.secondary.main }}
        title="Dispute Info"
      />
      <Divider />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className={classes.fontWeightMedium}>Dispute Date</TableCell>
            <TableCell align="right">
              <Typography variant="body2" color="textSecondary">
                {disputeDate?? '-'}
              </Typography>
            </TableCell>
          </TableRow>
          {stripeDisputeId && (
            <TableRow>
              <TableCell className={classes.fontWeightMedium}>Stripe Dispute Id</TableCell>
              <TableCell align="right">
                <Typography variant="body2" color="textSecondary">
                  {stripeDisputeId}
                </Typography>
              </TableCell>
            </TableRow>
          ) }
        </TableBody>
      </Table>
    </Card>
  );
}

DisputeInfo.propTypes = {
  disputeDate: PropTypes.string,
  stripeDisputeId: PropTypes.string,
};

export default DisputeInfo;
